import { Box, Hidden, Stack } from 'braid-design-system';
import type React from 'react';

import { DraftListDesktopAndTablet } from 'src/App/components/DraftJobsContent/DraftListDesktopAndTablet';
import { DraftListMobile } from 'src/App/components/DraftJobsContent/DraftListMobile';
import { JobSearchPanel } from 'src/App/components/JobSearchPanel/JobSearchPanel';
import { JobListDesktopAndTablet } from 'src/App/components/JobsContent/JobListDesktopAndTablet';
import { JobListMobile } from 'src/App/components/JobsContent/JobListMobile';
import { Skeleton } from 'src/App/components/Skeleton/Skeleton';
import { DraftStatus, PostType, JobStatus } from 'src/graphql/__generated__';
import type { QueryParamTab } from 'src/hooks/useQueryParam';
import type { DraftJob, Job } from 'src/types';

const mockDraftJob: DraftJob = {
  draftId: '1111',
  createdBy: 'Caitlin',
  createdDate: '2021-08-25T01:22:33Z',
  title: 'Senior Developer',
  status: DraftStatus.OPEN,
  location: { description: 'Cremorne, Victoria AU', country: 'au' },
};

const mockDraftJobs = Array(8)
  .fill(undefined)
  .map((_, index) => ({ ...mockDraftJob, draftId: index.toString() }));

const mockJob: Job = {
  title: 'Senior Full Stack Developer',
  jobId: '-1',
  numberOfCandidates: 250,
  numberOfNewCandidates: 2,
  postType: PostType.DIRECT,
  status: JobStatus.ACTIVE,
  location: {
    description: 'Melbourne, VIC 3000',
    country: 'au',
  },
  createdDate: '2021-06-30T02:34:56Z',
  createdBy: 'Caitlin',
  canBeRefreshed: false,
  canBeUpgraded: false,
};

const mockJobs = Array(8)
  .fill(undefined)
  .map((_, index) => ({ ...mockJob, jobId: index.toString() }));

interface Props {
  isDraft?: boolean;
  tab: QueryParamTab;
}

export const JobsListLoader: React.FC<React.PropsWithChildren<Props>> = ({
  tab,
}) => {
  const JobsTable = () => (
    <>
      <Hidden below="tablet">
        <JobListDesktopAndTablet loading={true} jobs={mockJobs} tab={tab} />
      </Hidden>

      <Hidden above="mobile">
        <JobListMobile loading={true} jobs={mockJobs} />
      </Hidden>
    </>
  );

  const DraftsTable = () => (
    <>
      <Hidden below="tablet">
        <DraftListDesktopAndTablet loading={true} draftJobs={mockDraftJobs} />
      </Hidden>

      <Hidden above="mobile">
        <DraftListMobile loading={true} draftJobs={mockDraftJobs} />
      </Hidden>
    </>
  );

  return (
    <Box aria-label="Loading">
      <Stack space="medium">
        <JobSearchPanel loading={true} />
        {tab === 'draft' ? <DraftsTable /> : <JobsTable />}
        <Box display="flex" justifyContent="center" paddingTop="xlarge">
          <Skeleton loading numberOfCharacters={50} height={68} />
        </Box>
      </Stack>
    </Box>
  );
};
